<div class="login-container">
    <div class="background">
        <div class="shape"></div>
        <div class="shape"></div>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm()" novalidate>


        <div class="form-group">
            <label>Email </label>
            <input type="email" class="form-control" formControlName="email" placeholder="Enter email">
        </div>

        <div class="form-group">
            <label>Password</label>
            <input type="password" class="form-control" formControlName="password" placeholder="Password">
        </div>


        <button type="submit">Login</button>
        <div class="d-flex mt-4 justify-content-center">
            <a class="forgotPassword" routerLink="/forgot-password">Forgot password?</a>
        </div>
    </form>
</div>